module.exports = __webpack_public_path__ + "static/media/pdi-image-03.3347504a.svg";